import AppButton from 'components/atoms/AppButton/AppButton'
import BreadcrumbTitle from 'components/atoms/BreadcrumbTitle/BreadcrumbTitle'
import HeaderPageSection from 'components/molecules/HeaderPageSection/HeaderPageSection'
import Layout from 'layout/Layout'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { showOrderDetails, getOrderReport } from 'services/ordersService'
import ShowOrderDetails from 'components/organisms/ShowOrderDetails/ShowOrderDetails'
import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent'
import Message, { MessageProps } from 'components/atoms/Message/Message'
import { ButtonDropdown } from 'components/molecules/ButtonDropdown/ButtonDropdown'
import { usePermissions } from 'hooks/usePermissions'
import { RolePermissions } from 'utils/constants'

export default function ShowOrderDetailsPage() {
    const navigate = useNavigate()
    const { orderId } = useParams()
    const orderIdNumber = Number(orderId)
    const { can } = usePermissions()
    const [loading, setLoading] = useState(false)
    const [order, setOrder] = useState({
        createdAt: '',
        description: '',
        groups: {},
        id: 0,
        state: '',
        total: 0,
        totalProcessed: 0,
        totalWithoutProcessed: 0,
    })
    const canExport = can(RolePermissions.rules.create)
    const [message, setMessage] = useState<MessageProps>({
        message: '',
        type: 'default',
    })
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const data = await showOrderDetails(orderIdNumber)
                setOrder(data)
                setLoading(false)
            } catch (error) {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    const sendReport = async () => {
        try {
            setLoading(true)
            const data = await getOrderReport(orderIdNumber)
            if (data.status === 200) {
                setMessage({
                    message:
                        'Se ha procesado correctamente, se estará enviado un correo electrónico con el reporte generado',
                    type: 'success',
                })
            } else {
                setMessage({
                    message:
                        'Ocurrió un error con la generación del reporte, intente nuevamente',
                    type: 'error',
                })
            }

            setLoading(false)
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setMessage({ message: error.data.message, type: 'error' })
            setLoading(false)
        }
    }

    return (
        <Layout>
            {loading && <LoaderTransparent />}
            <HeaderPageSection>
                <div className="flex gap-2 items-center">
                    <AppButton
                        title="Exportar"
                        state="ghost"
                        className="text-sm font-bold"
                        onClick={() => sendReport()}
                    />
                    {canExport && (
                        <ButtonDropdown
                            title={'Cargar orden'}
                            options={[
                                {
                                    title: 'Sin criterios',
                                    path: '/orders/create/no-template',
                                },
                                {
                                    title: 'Con criterios',
                                    path: '/orders/create/template',
                                },
                            ]}
                            color={'primary'}
                        />
                    )}
                </div>
            </HeaderPageSection>
            <div className="ml-6">
                <BreadcrumbTitle
                    title={`${order.description}: #${orderIdNumber}`}
                    subtitle="Detalle de la Orden"
                    goToBack={() => navigate('/orders')}
                />
                {message.message && (
                    <Message message={message.message} type={message.type} />
                )}
            </div>
            <ShowOrderDetails order={order} />
        </Layout>
    )
}
